import './common'
import '../scss/style.scss';

import '~components/forms/select/select'
import '~components/slider/slider'
import '~components/product/product'
import '~components/b-profile-favorites/b-profile-favorites'
